import { useMemo } from 'react'

import { useAccounts } from '@modules-deprecated/app/accounts/accountsContext'
import { Account } from '@modules-deprecated/app/accounts/types'

interface UseBookkeepingBankAccountsResponse {
  bookkeepingBankAccounts: Account[]
  isLoading: boolean
}

export const useBookkeepingBankAccounts = (): UseBookkeepingBankAccountsResponse => {
  const { accounts = [], isLoading } = useAccounts()
  const bookkeepingBankAccounts = useMemo(() => accounts.filter(({ isBankAccount }) => !!isBankAccount), [accounts])

  return {
    bookkeepingBankAccounts,
    isLoading,
  }
}
